<template>
  <div class="pricing-plan-modal">
    <div class="pricing-plan-modal__image">
      <FreeTrialImage v-if="type === 'trial_end'" width="100%" />
      <UpgradeImage v-if="type === 'upgrade'" width="100%" />
    </div>
    <div class="pricing-plan-modal__content">
      <slot name="badge" />
      <div class="pricing-plan-modal__title">{{ title }}</div>
      <div class="pricing-plan-modal__description">
        <slot name="description" />
      </div>
      <ul class="pricing-plan-modal__features">
        <li v-for="(feature, i) in features" :key="i">
          <i class="far fa-check" />
          <span>{{ feature.text }}</span>
        </li>
      </ul>
      <div class="pricing-plan-modal__buttons">
        <a-button type="primary" @click="$emit('click-get-essential-plan')">{{ get_essential_plan_text }}</a-button>
        <a-button type="subtle" @click="$emit('click-continue-starter-plan')">{{ continue_starter_plan_text }}</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import FreeTrialImage from './free-trial-image'
import UpgradeImage from './upgrade-image'
export default {
  name: 't-pricing-plan-modal',
  props: {
    title: String,
    features: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: 'trial_end'
    },
    get_essential_plan_text: {
      type: String,
      default: `Get Essential Plan`
    },
    continue_starter_plan_text: {
      type: String,
      default: `Continue with Starter Plan`
    }
  },
  components: {
    FreeTrialImage,
    UpgradeImage
  }
}
</script>

<style lang="scss">
.pricing-plan-modal {
  width: 996px;
  border-radius: 8px;
  box-shadow: 0 0 20px 0 rgba(0, 18, 50, 0.25);
  padding: 36px 24px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  .#{$badge} {
    text-transform: none;
  }
  &__image {
    width: 40%;
  }
  &__content {
    width: 50%;
    .pricing-plan-modal__title {
      margin-top: 8px;
      font-size: 30px;
      font-weight: $font-weight-semibold;
      color: $text-color;
    }
    .pricing-plan-modal__description {
      margin: 16px 0;
    }
    ul.pricing-plan-modal__features {
      li {
        margin: 12px 0;
        i {
          color: $primary-color;
          font-size: 16px;
        }
      }
    }
    .pricing-plan-modal__buttons {
      margin-top: 24px;
    }
  }
}
/* On screens that are 600px wide or less */
@media screen and (max-width: 600px) {
  .pricing-plan-modal {
    padding: 12px;
    flex-direction: column;
    > * {
      width: 100%;
    }
    .pricing-plan-modal__content .pricing-plan-modal__buttons {
      text-align: center;
    }
  }
}
</style>
